import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslations } from "next-intl";
import React, { FC } from "react";

import RichText from "@/components/rich_text";
import cn from "@/utils/core/cn";
import { abbreviatedNumber } from "@/utils/formatters/number";

type Props = {
  forecasters?: number;
  compact?: boolean;
  boldCount?: boolean;
  className?: string;
};

const ForecastersCounter: FC<Props> = ({
  forecasters,
  compact = false,
  boldCount = false,
  className,
}) => {
  const t = useTranslations();

  if (!forecasters) {
    return null;
  }

  const forecastersFormatted = abbreviatedNumber(
    forecasters,
    2,
    false,
    undefined,
    3
  );

  return (
    <div
      className={cn(
        "flex min-w-0 flex-row items-center gap-1.5 truncate px-1.5 text-justify text-sm font-normal leading-4 text-gray-700 dark:text-gray-700-dark md:gap-2",
        className
      )}
    >
      <FontAwesomeIcon
        icon={faUsers}
        className="text-gray-400 dark:text-gray-400-dark"
      />
      {/* Compact version - just shows number */}
      {compact && (
        <span
          className={cn("align-middle tabular-nums", boldCount && "font-bold")}
        >
          {forecastersFormatted}
        </span>
      )}
      {/* Full version - shows descriptive text with label */}
      {!compact && (
        <RichText>
          {(tags) => (
            <span className="align-middle tabular-nums">
              {t.rich("forecastersWithCount", {
                count: forecasters,
                count_formatted: forecastersFormatted,
                ...tags,
                strong: (chunks) =>
                  boldCount ? (
                    <span className="font-bold">{chunks}</span>
                  ) : (
                    chunks
                  ),
              })}
            </span>
          )}
        </RichText>
      )}
    </div>
  );
};

export default ForecastersCounter;
